export default {"src":"/_next/static/image/public/images/ic_rx_home.eec80bf9dce02bfb1f460777e80d75d7.svg","height":170,"width":119};